export default "__VITE_ASSET__PdK53QFj__"